import type { ReactNode } from "react";

import {
  type MediaDetailClose,
  MediaDetailControlsContext,
  type MediaDetailNavigation,
} from "src/components/media-detail/use-media-detail-controls";

type Props = {
  navigation: MediaDetailNavigation;
  close: MediaDetailClose;
  children: ReactNode;
};

/**
 * Hands the close and prev/next controls to the `MediaDetailHeader` rendered
 * somewhere inside the content, so the content that owns the title data does
 * not have to thread them through. `MediaDetailDialog` provides it with no
 * header close, since its close button sits in the dialog corner; a drawer
 * reusing the header wraps its content in this provider directly.
 */
export function MediaDetailControlsProvider({
  navigation,
  close,
  children,
}: Props) {
  return (
    <MediaDetailControlsContext.Provider value={{ navigation, close }}>
      {children}
    </MediaDetailControlsContext.Provider>
  );
}
